import { ApiServiceBase } from './apiServiceBase';
import { ILinkItem } from '../dto/ILinkItem';

export class MostVisitedService extends ApiServiceBase {
    private apiUrl = '/api/mostvisited/1.0';

    getMostVisited(onSuccess: (response: ILinkItem[]) => void, onFailure: (response: any) => void) {
        this.get(this.apiUrl, onSuccess, onFailure);
    }

    addVisited(pageId: number) {
        this.post(`${this.apiUrl}/${pageId}`, () => null, () => null)
    }
}